const USER_TRACKING_KEY = 'userTrackingObject'
const MY_TASKS_TRACKING_KEY = 'myTasksTrackingObject'

// Generic helpers
const readJSON = (storage, key) => {
  try {
    return JSON.parse(storage.getItem(key) || '{}')
  } catch {
    return {}
  }
}

const writeJSON = (storage, key, value) => {
  storage.setItem(key, JSON.stringify(value))
}

// userTrackingObject (localStorage) 
export const userTrackingStorage = {
  getAll() {
    return readJSON(localStorage, USER_TRACKING_KEY)
  },

  getForUser(userId) {
    if (!userId) return {}
    return this.getAll()?.[userId] || {}
  },

  setForUser(userId, partial) {
    if (!userId) return
    const all = this.getAll()
    all[userId] = { ...(all[userId] || {}), ...partial }
    writeJSON(localStorage, USER_TRACKING_KEY, all)
    return all[userId]
  },
}

// myTasksTrackingObject (sessionStorage) 
export const myTasksTrackingStorage = {
  getAll() {
    return readJSON(sessionStorage, MY_TASKS_TRACKING_KEY)
  },

  getForUser(userId) {
    if (!userId) return {}
    return this.getAll()?.[userId] || {}
  },

  setForUser(userId, partial) {
    if (!userId) return
    const all = this.getAll()
    all[userId] = { ...(all[userId] || {}), ...partial }
    writeJSON(sessionStorage, MY_TASKS_TRACKING_KEY, all)
    return all[userId]
  },
}